const globalVariable = require(`./${process.env.CONFIG_ENV}.app.js`)

// NOTE BUILD_NUMBER: jenkins build number
const BUILD_NUMBER =
  process.env.CONFIG_ENV === 'dev'
    ? process.env.npm_package_version
    : [process.env.npm_package_version, process.env.BUILD_NUMBER].join('@')

module.exports = {
  ...globalVariable,
  BUILD_NUMBER
}
